// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// //导入vuex
import store from "./store";

// jquery
import $ from "jquery";

//引入全局css
import "./assets/css/weui.css";
import "styles/reset.css";
import "./assets/css/global.css";
import "./assets/css/font_number.css";
// 引入element ui
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);
//解决1px border问题
import "styles/border.css";

//rem适配
import "./assets/js/flex-lib.min.js";
import { formatDate } from "@/assets/js/date.js";

//引用API文件
import api from "./api/api.js";
import myRegExp from "./assets/js/RegExp";
import myStorage from "./assets/js/sessionStorage";
import Convert_Pinyin from "./assets/js/Convert_Pinyin";
import returnTo from "./assets/js/returnTo";
import safeRule from "./assets/js/safeRule";

// 引用vconsole
// import vconsole from "vconsole";

//引用vant
import {
  DropdownMenu,
  DropdownItem,
  Button,
  Popup,
  Uploader,
  Lazyload,
  Search,
  Area,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Tab,
  Tabs,
  Toast,
  ActionSheet,
  Field,
  CellGroup,
  Picker,
  Cell,
  Row,
  Col,
  Loading,
  Dialog,
  List,
  Stepper,
  Collapse,
  CollapseItem,
  Overlay,
  Switch,
  Step,
  Steps,
  CountDown,
  PullRefresh,
  Icon,
  NoticeBar,
  TreeSelect,
} from "vant";
import moment from "vue-moment";
// import htmlToPdf from '@/components/htmlToPdf'
// import Vant from 'vant';
//use vant
Vue.use(Overlay);
Vue.use(Switch);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Stepper);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(moment);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Lazyload);
Vue.use(Tab).use(Tabs);
Vue.use(Search);
Vue.use(Area);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Picker);
Vue.use(Col);
Vue.use(Cell);
Vue.use(Row);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(List);
Vue.use(Step).use(Steps);
Vue.use(Step).use(CountDown);
Vue.use(Step).use(PullRefresh);
Vue.use(Icon);
Vue.use(NoticeBar);
Vue.use(TreeSelect);
// 关键：正确注册并配置，确保 $viewer 挂载到 Vue 原型
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999, // 确保弹窗在最上层
    inline: false, // 非 inline 模式（弹窗形式）
    navbar: true, // 显示导航栏
    toolbar: {
      zoomIn: true,
      zoomOut: true,
      oneToOne: true,
      reset: true,
      rotateLeft: true,
      rotateRight: true,
      flipHorizontal: true,
      flipVertical: true,
    }
  },
  name: 'viewer' // 可选，默认就是 'viewer'，确保与调用一致
})
// let vConsole = new vconsole();
// Vue.use(vConsole);

Vue.filter("orderStatus", function (status) {
  let a;
  a =
    status == 0
      ? "待邮寄"
      : status == 1
        ? "待签收"
        : status == 2
          ? "申请取消"
          : status == 3
            ? "申请驳回"
            : status == 4
              ? "申请成功"
              : status == 5
                ? "待核对"
                : "核对不通过";
  return a;
});

Vue.filter("status", function (status) {
  status == "DT0000000825" ||
    status == "DT0000000827" ||
    status == "DT0000000828"
    ? " 待处理"
    : status == "DT0000000907"
      ? " 待抢单"
      : status == "DT0000000899"
        ? " 客户取消"
        : status == "DT0000000909"
          ? " 待抢单"
          : status == "DT0000000908"
            ? " 已退单"
            : status == "DT0000000826"
              ? " 待处理"
              : status == "DT0000000829"
                ? " 待处理"
                : status == "DT0000000853"
                  ? " 待处理"
                  : status == "DT0000000831"
                    ? " 处理成功"
                    : status == "DT0000000832"
                      ? " 处理失败"
                      : status == "DT0000000830"
                        ? " 部分完成"
                        : status == "DT0000000858"
                          ? " 待处理"
                          : status == "DT0000000919"
                            ? " 待处理"
                            : status == "DT0000000920"
                              ? " 待处理"
                              : "";
});
Vue.filter("PayStatus", function (str) {
  console.log(str);
  switch (str) {
    case 0:
      return "无需支付";
    case 1:
      return "未收款";
    case 2:
      return "已收款";
    case 3:
      return "已退款";
    case 4:
      return "退款失败";
  }
});

Vue.filter("orderType", function (type) {
  switch (type) {
    case "DT0000000807":
      return "备案";
    case "DT0000000808":
      return "车辆抵押";
    case "DT0000000809":
      return "解除车辆抵押";
    case "DT0000000810":
      return "新车上牌";
    case "DT0000000811":
      return "本地过户";
    case "DT0000000813":
      return "车辆迁出";
    case "DT0000000814":
      return "车辆迁入";
    case "DT0000000815":
      return "新车上牌+车辆抵押";
    case "DT0000000816":
      return "本地过户+车辆抵押";
    case "DT0000000817":
      return "车辆迁入+车辆抵押";
    case "DT0000000819":
      return "车辆解押+本地过户";
    case "DT0000000820":
      return "车辆解押+车辆迁出";
  }
});

Vue.filter("personType", function (type) {
  switch (type) {
    case 1:
      return true;
    case 2:
      return true;
    case 5:
      return true;
    case 9:
      return true;
    default:
      return false;
  }
});

Vue.filter("isNull", function (entity) {
  if (!entity || entity === " ") {
    return "空";
  } else {
    return entity;
  }
});

Vue.filter("isNulltem", function (entity) {
  if (!entity || entity === " ") {
    return "-";
  } else {
    return entity;
  }
});

Vue.filter("longStr", function (str) {
  if (str.length > 11) {
    return str.substring(0, 11) + "...";
  } else {
    return str;
  }
});
Vue.filter("longStr1", function (str) {
  if (str.length > 5) {
    return str.substring(0, 4) + "...";
  } else {
    return str;
  }
});
Vue.filter("batchOrderStatus", function (status) {
  let a;
  a =
    status == 601
      ? "工单办理进度中"
      : status == 602
        ? "工单办理超期"
        : status == 603
          ? "工单完成（异常）"
          : status == 604
            ? "工单超期完成"
            : status == 605
              ? "工单完成"
              : '--';
  return a;
});

// Vue.filter("safeRule", function (value, num1, num2) {
//   if (value) {
//     return value.substr(0, num1) + '****' + value.substr(value.length - num2, value.length);
//   } else {
//     return '--';
//   }
// });

//防止双击
Vue.directive("loading", {
  componentUpdated: function (el, binding) {
    if (binding.value == true) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "请稍后..."
      });
    } else {
      Toast.clear();
    }
  }
});
//将API方法绑定到全局
Vue.prototype.$api = api;
Vue.prototype.myStorage = myStorage;
Vue.prototype.myRegExp = myRegExp;
Vue.prototype.Convert_Pinyin = Convert_Pinyin;
Vue.prototype.returnTo = returnTo;
Vue.prototype.safeRule = safeRule;
Vue.config.productionTip = false;


window.bus = new Vue({});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js